var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourcesDesktopApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Desktop_App",
    "data-name": "Desktop App",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.786,
    height: 25.54,
    viewBox: "0 0 26.786 25.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_00000115480656455809876520000009748704238352922530_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19651",
    "data-name": "Path 19651",
    d: "M26.786,16.176v13.7a3.424,3.424,0,0,1-3.426,3.426H3.426A3.424,3.424,0,0,1,0,29.88v-13.7A3.424,3.424,0,0,1,3.426,12.75H23.36a3.424,3.424,0,0,1,3.426,3.426Z",
    transform: "translate(0 -12.75)",
    fill: "#7dbaab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19652",
    "data-name": "Path 19652",
    d: "M106.38,497.25a.934.934,0,1,1,0,1.869h-16.2a.934.934,0,1,1,0-1.869Z",
    transform: "translate(-84.89 -473.579)",
    fill: "#7dbaab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19653",
    "data-name": "Path 19653",
    d: "M210.852,459v2.8a.935.935,0,0,1-.934.934h-4.983A.935.935,0,0,1,204,461.8V459Z",
    transform: "translate(-194.033 -437.198)",
    fill: "#7dbaab",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesDesktopApp);
export default __webpack_public_path__ + "static/media/Resources-Desktop-App.cc141fbcf61a5d34adb674a8232ec766.svg";
export { ForwardRef as ReactComponent };